/*=============================================== ProgressBar ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled, { keyframes, css } from "styled-components";
import Variables from "./Variables";
/*==================== Component ====================*/
var ProgressBar = function (_a) {
    var value = _a.value, _b = _a.color, color = _b === void 0 ? "primary" : _b, _c = _a.animated, animated = _c === void 0 ? true : _c, props = __rest(_a, ["value", "color", "animated"]);
    return React.createElement(Container, __assign({ "$value": value, "$animated": animated, "$color": color }, props));
};
export default ProgressBar;
/*==================== Styles ====================*/
var Progress = function (_a) {
    var $value = _a.$value;
    return keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% {\n        width: 0;\n    }\n\n    100% {\n        width: ", "%;\n    }\n"], ["\n    0% {\n        width: 0;\n    }\n\n    100% {\n        width: ", "%;\n    }\n"])), $value);
};
var Container = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n    height: 16px;\n    background-color: ", ";\n    border-radius: ", ";\n    position: relative;\n    display: block;\n    overflow: hidden;\n\n    &:before {\n        content: \"\";\n        position: absolute;\n        width: ", "%;\n        height: 100%;\n        border-radius: ", ";\n        transition: ", ";\n        background-color: ", ";\n\n        ", "\n    }\n"], ["\n    width: 100%;\n    height: 16px;\n    background-color: ", ";\n    border-radius: ", ";\n    position: relative;\n    display: block;\n    overflow: hidden;\n\n    &:before {\n        content: \"\";\n        position: absolute;\n        width: ", "%;\n        height: 100%;\n        border-radius: ", ";\n        transition: ", ";\n        background-color: ", ";\n\n        ", "\n    }\n"])), function (_a) {
    var $color = _a.$color;
    return ($color === "white" ? Variables.Colors.Gray900 : Variables.Colors.Gray100);
}, Variables.Radiuses.Round, function (_a) {
    var $value = _a.$value;
    return $value;
}, function (_a) {
    var $value = _a.$value;
    return $value < 3 ? Variables.Radiuses.Circle : Variables.Radiuses.Round;
}, Variables.Transitions.Short, function (_a) {
    var $color = _a.$color;
    return $color === "secondary"
        ? Variables.Colors.Secondary500
        : $color === "success"
            ? Variables.Colors.Success500
            : $color === "danger"
                ? Variables.Colors.Danger500
                : $color === "warning"
                    ? Variables.Colors.Warning500
                    : $color === "gray"
                        ? Variables.Colors.Gray500
                        : $color === "black"
                            ? Variables.Colors.Black
                            : $color === "white"
                                ? Variables.Colors.White
                                : Variables.Colors.Primary500;
}, function (_a) {
    var $animated = _a.$animated, $value = _a.$value;
    return $animated && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                animation: ", " calc(", " * 50ms) 1;\n            "], ["\n                animation: ", " calc(", " * 50ms) 1;\n            "])), Progress({ $value: $value }), $value);
});
var templateObject_1, templateObject_2, templateObject_3;
